var map = {
	"./dlt_kind_1.svg.bak.svg": "1960",
	"./dlt_kind_2.svg.bak.svg": "ca0c",
	"./dlt_kind_3.svg": "c028",
	"./dlt_kind_4.svg": "3b30",
	"./dlt_kind_5.svg": "eb1f",
	"./dlt_kind_6.svg": "7ca0",
	"./dlt_kind_7.svg.bak.svg": "f9e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec65";